export default __webpack_public_path__ + "static/media/floor~uBSrMzEP.e022227a.svg";